/**
 * SiteCard — bottom-right card with site image, name, and metadata.
 */

import './SiteCard.css';

export interface SiteInfo {
  name: string;
  location: string;
  capacity: number;  // kWp
  installDate: string;
  lastInspection: string;
  imageUrl?: string;
}

const MOCK_SITE: SiteInfo = {
  name:           'Hadera Solar Park',
  location:       'Hadera, Israel',
  capacity:       2840,
  installDate:    '2022-08-10',
  lastInspection: '2025-11-14',
};

interface SiteCardProps {
  site?: SiteInfo;
}

export default function SiteCard({ site = MOCK_SITE }: SiteCardProps) {
  const capacityStr = site.capacity >= 1000
    ? `${(site.capacity / 1000).toFixed(1)} MWp`
    : `${site.capacity} kWp`;

  return (
    <div className="site-card card">
      {/* Site thumbnail */}
      <div className="site-card__image">
        {site.imageUrl ? (
          <img src={site.imageUrl} alt={site.name} className="site-card__img" />
        ) : (
          <div className="site-card__placeholder" aria-hidden>
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2">
              <rect x="2" y="7" width="20" height="14" rx="1"/>
              <line x1="2"  y1="12" x2="22" y2="12"/>
              <line x1="12" y1="7"  x2="12" y2="21"/>
              <line x1="7"  y1="7"  x2="7"  y2="21"/>
              <line x1="17" y1="7"  x2="17" y2="21"/>
              <path d="M7 7V5a5 5 0 0 1 10 0v2"/>
            </svg>
          </div>
        )}
      </div>

      {/* Details */}
      <div className="site-card__body">
        <div className="site-card__name-row">
          <h3 className="site-card__name">{site.name}</h3>
          <span className="site-card__location">{site.location}</span>
        </div>

        <div className="site-card__stats">
          <div className="site-stat">
            <span className="site-stat__label">Capacity</span>
            <span className="site-stat__value tabular">{capacityStr}</span>
          </div>
          <div className="site-stat">
            <span className="site-stat__label">Installed</span>
            <span className="site-stat__value">{site.installDate}</span>
          </div>
          <div className="site-stat">
            <span className="site-stat__label">Last inspection</span>
            <span className="site-stat__value site-stat__value--highlight">{site.lastInspection}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
